import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './call/HttpClientCall.mjs';
import {
  toString1pkumu07cwy4m as toString,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { PipelineContext34fsb0mycu471 as PipelineContext } from '../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelineContext.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { defaultTransformers2r9wd7ftt31zw as defaultTransformers } from './plugins/DefaultTransform.mjs';
import {
  get_HttpResponseReceiveFailed2q0s5em07bm9j as get_HttpResponseReceiveFailed,
  HttpResponseReceiveFailk4vfmxmwithf as HttpResponseReceiveFail,
  get_HttpRequestCreated2xa7wfn254wyu as get_HttpRequestCreated,
} from './utils/ClientEvents.mjs';
import {
  HttpResponseContainer3r9yzy4mwwvc9 as HttpResponseContainer,
  HttpResponsePipeline14ucx7kbf4hm2 as HttpResponsePipeline,
  HttpReceivePipeline1ousblrss634z as HttpReceivePipeline,
  Phases_getInstance1ydmp5ct4mzr8 as Phases_getInstance,
} from './statement/HttpResponsePipeline.mjs';
import { HttpClientConfigo6p492ed655g as HttpClientConfig } from './HttpClientConfig.mjs';
import { atomic$boolean$1iggki4z65a2h as atomic$boolean$1 } from '../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import {
  Key_instance2rlngjw9v1qsd as Key_instance,
  Job13y4jkazwjho0 as Job,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import {
  HttpRequestPipeline1v7xct5dgezuy as HttpRequestPipeline,
  HttpSendPipeline3tm1hram7cjxt as HttpSendPipeline,
  Phases_getInstance2itgh2akpxu95 as Phases_getInstance_0,
} from './request/HttpRequestPipeline.mjs';
import { AttributesJsFn25rjfgcprgprf as AttributesJsFn } from '../../../../ktor-ktor-utils/io/ktor/util/Attributes.web.mjs';
import { Events63tfxre48w4z as Events } from '../../../../ktor-ktor-events/io/ktor/events/Events.mjs';
import { get_HttpRequestLifecycle1e7j0z243lnj5 as get_HttpRequestLifecycle } from './plugins/HttpRequestLifecycle.mjs';
import { get_BodyProgresstom4nhodv8bj as get_BodyProgress } from './plugins/BodyProgress.mjs';
import { get_SaveBody3aignvhtsnvcr as get_SaveBody } from './plugins/SaveBody.mjs';
import { Plugin_getInstance1dclwrituae7c as Plugin_getInstance } from './plugins/HttpSend.mjs';
import { get_HttpCallValidator3iji36qylbtbr as get_HttpCallValidator } from './plugins/HttpCallValidator.mjs';
import { get_HttpRedirect1lgx3wewnhrb0 as get_HttpRedirect } from './plugins/HttpRedirect.mjs';
import { get_HttpPlainText2hd9sygnz4kij as get_HttpPlainText } from './plugins/HttpPlainText.mjs';
import { addDefaultResponseValidation1d06vtgr9flaj as addDefaultResponseValidation } from './plugins/DefaultResponseValidation.mjs';
import { HttpClientEngineBase2tgisnw4e4drr as HttpClientEngineBase } from './engine/HttpClientEngineBase.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import {
  cancel36mj9lv3a0whl as cancel,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { get_PLUGIN_INSTALLED_LIST1ftwjhwye1pz5 as get_PLUGIN_INSTALLED_LIST } from './plugins/HttpClientPlugin.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import { AutoCloseable1l5p57f9lp7kv as AutoCloseable } from '../../../../kotlin-kotlin-stdlib/kotlin/AutoCloseableJs.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HttpClient$slambdaClass;
function HttpClient$slambda() {
  if (HttpClient$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.g5l_1 = this$0;
      }
      *h5l($this$intercept, call, $completion) {
        // Inline function 'kotlin.check' call
        if (!(call instanceof HttpClientCall())) {
          var message = 'Error: HttpClientCall expected, but found ' + toString(call) + '(' + toString(getKClassFromExpression(call)) + ').';
          throw IllegalStateException().o(toString(message));
        }
        var response = yield* this.g5l_1.r5l_1.v4w(Unit_instance, call.b5m(), $completion);
        call.c5m(response);
        yield* $this$intercept.y4v(call, $completion);
        return Unit_instance;
      }
      pd(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.h5l(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    HttpClient$slambdaClass = $;
  }
  return HttpClient$slambdaClass;
}
function HttpClient$slambda_0(this$0) {
  var i = new (HttpClient$slambda())(this$0);
  var l = ($this$intercept, call, $completion) => i.h5l($this$intercept, call, $completion);
  l.$arity = 2;
  return l;
}
function HttpClient$lambda($this$install) {
  defaultTransformers($this$install);
  return Unit_instance;
}
var HttpClient$slambdaClass_0;
function HttpClient$slambda_1() {
  if (HttpClient$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.d5m_1 = this$0;
      }
      *e5m($this$intercept, it, $completion) {
        try {
          yield* $this$intercept.z4v($completion);
        } catch ($p) {
          if ($p instanceof Error) {
            var cause = $p;
            this.d5m_1.u5l_1.c4y(get_HttpResponseReceiveFailed(), new (HttpResponseReceiveFail())($this$intercept.w4w_1.b5m(), cause));
            throw cause;
          } else {
            throw $p;
          }
        }
        return Unit_instance;
      }
      pd(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.e5m(tmp, p2 instanceof HttpResponseContainer() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    HttpClient$slambdaClass_0 = $;
  }
  return HttpClient$slambdaClass_0;
}
function HttpClient$slambda_2(this$0) {
  var i = new (HttpClient$slambda_1())(this$0);
  var l = ($this$intercept, it, $completion) => i.e5m($this$intercept, it, $completion);
  l.$arity = 2;
  return l;
}
var HttpClientClass;
function HttpClient() {
  if (HttpClientClass === VOID) {
    class $ {
      static f5m(engine, userConfig) {
        userConfig = userConfig === VOID ? new (HttpClientConfig())() : userConfig;
        var $this = createThis(this);
        $this.i5l_1 = engine;
        $this.j5l_1 = userConfig;
        $this.k5l_1 = false;
        $this.l5l_1 = atomic$boolean$1(false);
        $this.m5l_1 = Job($this.i5l_1.gw().bd(Key_instance));
        $this.n5l_1 = $this.i5l_1.gw().um($this.m5l_1);
        $this.o5l_1 = new (HttpRequestPipeline())();
        $this.p5l_1 = new (HttpResponsePipeline())();
        $this.q5l_1 = new (HttpSendPipeline())();
        $this.r5l_1 = new (HttpReceivePipeline())();
        $this.s5l_1 = AttributesJsFn(true);
        $this.t5l_1 = $this.i5l_1.g5m();
        $this.u5l_1 = new (Events())();
        $this.v5l_1 = new (HttpClientConfig())();
        $this.i5l_1.h5m($this);
        var tmp = Phases_getInstance_0().m5m_1;
        $this.q5l_1.a4x(tmp, HttpClient$slambda_0($this));
        // Inline function 'kotlin.with' call
        var $this$with = $this.j5l_1;
        $this.v5l_1.v5m(get_HttpRequestLifecycle());
        $this.v5l_1.v5m(get_BodyProgress());
        $this.v5l_1.v5m(get_SaveBody());
        if ($this$with.s5m_1) {
          $this.v5l_1.w5m('DefaultTransformers', HttpClient$lambda);
        }
        $this.v5l_1.v5m(Plugin_getInstance());
        $this.v5l_1.v5m(get_HttpCallValidator());
        if ($this$with.r5m_1) {
          $this.v5l_1.v5m(get_HttpRedirect());
        }
        $this.v5l_1.x5m($this$with);
        if ($this$with.s5m_1) {
          $this.v5l_1.v5m(get_HttpPlainText());
        }
        addDefaultResponseValidation($this.v5l_1);
        $this.v5l_1.h5m($this);
        var tmp_0 = Phases_getInstance().y5m_1;
        $this.p5l_1.a4x(tmp_0, HttpClient$slambda_2($this));
        return $this;
      }
      static d5n(engine, userConfig, manageEngine) {
        var $this = this.f5m(engine, userConfig);
        $this.k5l_1 = manageEngine;
        if ($this.k5l_1) {
          if (engine instanceof HttpClientEngineBase()) {
            engine.g5n_1.atomicfu$incrementAndGet();
          }
          var tmp = ensureNotNull($this.n5l_1.bd(Key_instance));
          tmp.jx((cause) => {
            var tmp;
            if (!(engine instanceof HttpClientEngineBase())) {
              tmp = true;
            } else {
              tmp = engine.g5n_1.atomicfu$decrementAndGet() <= 0;
            }
            var shouldClose = tmp;
            var tmp_0;
            if (shouldClose) {
              var tmp_1;
              if (cause == null) {
                engine.l6();
                tmp_1 = Unit_instance;
              } else {
                var tmp0_elvis_lhs = cause instanceof CancellationException() ? cause : null;
                cancel(engine, tmp0_elvis_lhs == null ? CancellationException().p('Client scope is canceled', cause) : tmp0_elvis_lhs);
                tmp_1 = Unit_instance;
              }
              tmp_0 = tmp_1;
            }
            return Unit_instance;
          });
        }
        return $this;
      }
      gw() {
        return this.n5l_1;
      }
      *j5n(builder, $completion) {
        this.u5l_1.c4y(get_HttpRequestCreated(), builder);
        var tmp = yield* this.o5l_1.v4w(builder, builder.n5n_1, $completion);
        return tmp instanceof HttpClientCall() ? tmp : THROW_CCE();
      }
      l6() {
        var success = this.l5l_1.atomicfu$compareAndSet(false, true);
        if (!success)
          return Unit_instance;
        var installedFeatures = this.s5l_1.i4r(get_PLUGIN_INSTALLED_LIST());
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = installedFeatures.p4r().p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          var plugin = installedFeatures.i4r(element instanceof AttributeKey() ? element : THROW_CCE());
          if (isInterface(plugin, AutoCloseable())) {
            plugin.l6();
          }
        }
        this.m5l_1.y12();
      }
      toString() {
        return 'HttpClient[' + toString(this.i5l_1) + ']';
      }
    }
    initMetadataForClass($, 'HttpClient', VOID, VOID, [CoroutineScope(), AutoCloseable()], [1]);
    HttpClientClass = $;
  }
  return HttpClientClass;
}
function HttpClient_0(engine, block) {
  // Inline function 'kotlin.apply' call
  var this_0 = new (HttpClientConfig())();
  block(this_0);
  return HttpClient().d5n(engine, this_0, false);
}
function HttpClient_1(engineFactory, block) {
  var tmp;
  if (block === VOID) {
    tmp = HttpClient$lambda_0;
  } else {
    tmp = block;
  }
  block = tmp;
  // Inline function 'kotlin.apply' call
  var this_0 = new (HttpClientConfig())();
  block(this_0);
  var config = this_0;
  var engine = engineFactory.q5n(config.q5m_1);
  return HttpClient().d5n(engine, config, true);
}
function HttpClient$lambda_0(_this__u8e3s4) {
  return Unit_instance;
}
//region block: exports
export {
  HttpClient_0 as HttpClienthpouyso1j6ge,
  HttpClient_1 as HttpClient2x7qc5z8fmeal,
};
//endregion

//# sourceMappingURL=HttpClient.mjs.map
